/**
 * Project : workspace
 * File    : ProductCard.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.product

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.parmartechnologies.commerce.feature.alert.viewModel.AlertViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.ui.component.image.Image
import component.alert.AlertDialogue
import component.button.DefaultButton
import component.button.StepperButton
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import locale.localization
import theme.ThemeColor

/**
 * Represents the product card class.
 */

class ProductCard( val product: Product,
                   val viewModel: CartViewModel,
                   val param: NavigationParam?,
                   val inventory: List<Inventory> = listOf<Inventory>(),
                   val onClick: (Product) -> Unit = {},
                   val selectedProductId : String = "",
                   val onClickSelect: (Product) -> Unit = {}) {
    /**
 * Executes the get quantity operation.
 *
 * @receiver TODO
 * @param list The list.
 * @return The resulting long.
 */
    fun getQuantity(list: List<CartItem>): Long{
        var quantity = 0L
        list.forEach {
            if(product._id == it.product._id){
                quantity = it.quantity.toLong()
            }
        }
        return quantity
    }
    /**
 * Executes the get item operation.
 *
 * @receiver TODO
 * @param list The list.
 * @return The resulting cart item?.
 */
    fun getItem(list: List<CartItem>): CartItem?{
        var item : CartItem? = null
        list.forEach {
            if(product._id == it.product._id){
                item = it
            }
        }
        return item
    }
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun content(){
        val alertViewModel = AlertViewModel()
        val allItems = viewModel.cartItems.collectAsState()
        val cartItem = getItem(allItems.value)

        val lowestProduct: Inventory? = inventory.minByOrNull {inv:Inventory-> inv.ProductPrice?.FinalPrice!! }
        val highestProduct: Inventory? = inventory.maxByOrNull {inv:Inventory-> inv.ProductPrice?.FinalPrice!! }

    var productFinalPrice = product.ProductPrice.FinalPrice.toString()
    var productQuantity = product.Quantity
    var productMRP = product.ProductPrice.MRP.toString()
    if (inventory.size == 1) {
        productFinalPrice = inventory[0].ProductPrice?.FinalPrice.toString()
        productQuantity = inventory[0].Quantity
        productMRP = inventory[0].ProductPrice?.MRP.toString()
    } else if (lowestProduct != null && highestProduct != null) {
        productFinalPrice =
            "Range - ${lowestProduct.ProductPrice?.FinalPrice} - ${highestProduct.ProductPrice?.FinalPrice}"
        productQuantity = inventory.sumOf { inv:Inventory-> inv.Quantity }
    }
    val isOutOfStock = viewModel.isOutOfStock(product,cartItem)
    Card(
        modifier = Modifier
            .width(180.dp)
            .wrapContentHeight()
            .padding(top = 12.dp, start = 4.dp, end = 4.dp)
            .background(ThemeColor.shared().White, shape = RoundedCornerShape(10.dp)),
        colors = CardDefaults.cardColors(
            containerColor = ThemeColor.shared().White,
            contentColor = Color.Black,
            disabledContainerColor = ThemeColor.shared().White
        ),
        elevation = CardDefaults.cardElevation(
            defaultElevation = 4.dp
        )
    ) {
        if (inventory.isNotEmpty() && selectedProductId == product._id) {
            AlertDialogue(viewModel = alertViewModel) {
                Card(
                    modifier = Modifier
                        .fillMaxWidth()
                        .wrapContentHeight()
                        .background(Color.White, shape = RoundedCornerShape(16.dp)),
                    elevation = CardDefaults.cardElevation(defaultElevation = 4.dp),
                    colors = CardDefaults.cardColors(containerColor = Color.White),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = product.Name,
                            fontSize = 20.sp,
                            fontWeight = FontWeight.Bold
                        )

                            Spacer(modifier = Modifier.height(16.dp))

                            LazyVerticalGrid(
                                columns = GridCells.Adaptive(minSize = 180.dp),
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .heightIn(max = 300.dp) // allows scrolling if items exceed
                            ) {
                                items(inventory.count()) {
                                    param?.product = product
                                    InventoryItemCard(inventory[it], viewModel, param)
                                }
                            }

                            Spacer(modifier = Modifier.height(16.dp))

                            DefaultButton(
                                title = localization().button.doneButton,
                                onClick = {
                                    CoroutineScope(Job() + Dispatchers.Default).launch {
                                        alertViewModel.repository.isAlertVisible.emit(false)
                                    }
                                },
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(50.dp)
                            )
                        }
                    }
                }
            }
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(0.dp)
            ) {
                Column(
                    modifier = Modifier.clickable {
                        onClick(product)
                    },
                ) {
                    Box (
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(120.dp)
                    ) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(120.dp).zIndex(-1f)
                        ) {
                            Image().content(product._id)
                        }
                        if(isOutOfStock){
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .background(Color.Red.copy(alpha = 0.7f), RoundedCornerShape(8.dp))
                                    .padding(8.dp)
                                    .zIndex(1f)
                                ,
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    text = "Out of Stock",
                                    color = Color.White,
                                    fontSize = 14.sp,
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                        else if((productQuantity - getQuantity(allItems.value).toInt())  < 3){
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .background(Color.Red.copy(alpha = 0.7f), RoundedCornerShape(8.dp))
                                    .padding(8.dp)
                                    .zIndex(1f)
                                ,
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    text = "${(productQuantity - getQuantity(allItems.value).toInt())} Qty left",
                                    color = Color.White,
                                    fontSize = 14.sp,
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                    }

                    Text(
                        product.Name,
                        fontSize = 14.sp,
                        color = Color.Black,
                        maxLines = 1,
                        modifier = Modifier.fillMaxWidth().wrapContentHeight()
                            .padding(start = 8.dp, end = 8.dp)
                    )
                    Text(
                        product.Description,
                        fontSize = 10.sp,
                        color = Color.Gray,
                        maxLines = 1,
                        modifier = Modifier.wrapContentHeight()
                            .padding(start = 8.dp, end = 8.dp)
                    )
                }
                Column(
                    modifier = Modifier.wrapContentHeight().fillMaxWidth()
                        .padding(start = 8.dp, end = 8.dp),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        modifier = Modifier.height(40.dp).fillMaxWidth()
                            .padding(start = 8.dp, bottom = 8.dp, end = 8.dp),
                    ) {
                            Text(
                                "${product.ProductPrice.currency?.symbol} $productFinalPrice",
                                fontSize = 14.sp,
                                color = Color.Black,
                                maxLines = 1,
                                modifier = Modifier
                                    .padding(bottom = 8.dp)
                            )
                            Text(
                                "${product.ProductPrice.currency?.symbol} $productMRP",
                                fontSize = 10.sp,
                                color = Color.Gray,
                                maxLines = 1,
                                modifier = Modifier
                                    .weight(0.1f).padding(bottom = 8.dp),
                                style = TextStyle(textDecoration = TextDecoration.LineThrough)
                            )
                    }
                    if ((allItems.value.isNotEmpty() && cartItem != null && productQuantity > 0) && inventory.isEmpty()) {
                        Row(
                            modifier = Modifier.height(40.dp).fillMaxWidth()
                                .padding(start = 8.dp, bottom = 8.dp, end = 8.dp),
                        ) {
                            StepperButton(
                                count = getQuantity(allItems.value).toInt(),
                                availableCount = productQuantity,
                                onDecrease = { viewModel.removeFromCart(product, param) },
                                onIncrease = {
                                    viewModel.addToCart(product, param){
                                    }
                                }
                            )
                        }
                    } else {
                        Row(
                            modifier = Modifier.height(40.dp).fillMaxWidth()
                                .padding(start = 8.dp, bottom = 8.dp, end = 8.dp),
                            horizontalArrangement = Arrangement.End,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Row(
                                modifier = Modifier.height(30.dp).fillMaxWidth().padding(end = 0.dp)
                                    .background(
                                        ThemeColor.shared().PrimaryColor,
                                        shape = RoundedCornerShape(20.dp)
                                    ).clickable {
                                        onClickSelect(product)
//                                    AlertHandler.shared().showAlert("Oops!","We can't add because we are not available in your city.We are expanding and hopefully will be able to serve you.")
                                        if (inventory.isEmpty()) {
                                            if(!isOutOfStock){
                                                viewModel.addToCart(product, param){
                                                    print(it)
                                                }
                                            }
                                        }else{
                                            alertViewModel.showAlert()
                                        }
                                    },
                                horizontalArrangement = Arrangement.Center,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(text = "Add", color = ThemeColor.shared().White)
                                Icon(
                                    Icons.Default.Add,
                                    contentDescription = "increase quantity",
                                    tint = ThemeColor.shared().White
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
